import { defineComponent as _defineComponent } from 'vue'
import useRoomInfo from './useRoomInfoHooks';
import SvgIcon from '../../common/base/SvgIcon.vue';
import Arrow from '../../common/icons/ArrowUpIcon.vue';
import copyIcon from '../../common/icons/CopyIcon.vue';
import RoomTime from '../../common/RoomTime.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RoomInfoH5',
  setup(__props) {

const {
  t,
  isWeChat,
  arrowDirection,
  handleCloseRoomInfo,
  isShowRoomInfo,
  isShowRoomInfoTitle,
  conferenceTitle,
  roomInfoTabList,
  toggleShowRoomInfoStatus,
  onCopy,
} = useRoomInfo();

return { __sfc: true,t, isWeChat, arrowDirection, handleCloseRoomInfo, isShowRoomInfo, isShowRoomInfoTitle, conferenceTitle, roomInfoTabList, toggleShowRoomInfoStatus, onCopy, SvgIcon, Arrow, copyIcon, RoomTime }
}

})